export default "__VITE_ASSET__28c78d0a__"